'use client'

import SectionTabs from '@component/layout/section/tabs'
import { useHouseLivingOptionsContext } from '../context'
import { useCallback } from 'react'
import { propertyDataLayer } from '@plugin/google/gtm/modules/property'
import Select from '@component/select'
import { size } from 'lodash-es'

export default function HouseLivingOptionsTabs() {

  const { tab, setTab, tabs } = useHouseLivingOptionsContext()

  const changeHandle = useCallback(item => {
    setTab(item)
    propertyDataLayer.propertyValueChange(item)
  }, [setTab])

  return (
    <>
      <SectionTabs data={tabs} value={tab} onChange={changeHandle} theme='block' className='mt-10 sm:mt-0 hidden md:flex'></SectionTabs>
      {
        size(tabs) > 0
          ? (
            <div className='md:hidden border border-b-0 w-full rounded-t-sm h-42 flex items-center justify-center mt-16'>
              {
                size(tabs) > 1
                  ? <Select data={tabs} value={tab} onChange={changeHandle} popWidth={240} className='w-240 text-center'></Select>
                  : <span className='text-primary'>{tabs[0].label}</span>
              }
            </div>
          )
          : <div className='w-full mt-16 md:hidden'></div>
      }
    </>
  )
}